import { Controller } from "@hotwired/stimulus"
import { reloadFrame } from "../util"

// Connects to data-controller="dialog-list"
export default class extends Controller {
  static values = { dialogId: String };
  static targets = [];

  connect() {
    const handler = () => reloadFrame("dialogs_list")

    document.getElementById("dialogs-wrapper").addEventListener("new-message", handler)
    document.getElementById("dialogs-wrapper").addEventListener("deleted-message", handler)
  }

  updateUrlWithDialogId(event) {
    const dialogId = event.currentTarget.dataset.dialogListDialogIdValue;
    if (!dialogId) return;

    const url = new URL(window.location.href);
    url.searchParams.set("dialog_id", dialogId);
    url.searchParams.delete("chat_id");
    window.history.replaceState({}, "", url.toString());
  }

  updateUrlWithChatId(event) {
    const chatId = event.currentTarget.dataset.dialogListChatIdValue;
    if (!chatId) return;

    const url = new URL(window.location.href);
    url.searchParams.set("chat_id", chatId);
    url.searchParams.delete("dialog_id");
    window.history.replaceState({}, "", url.toString());
  }
}
